export const isOneFrequency = product => product?.availableDumbPeriods?.length === 1;
